import React from 'react';
import { Col, Form as RBForm } from 'react-bootstrap';

import './Form.scss';

interface IProps {
  children?: React.ReactNode;
  formId?: string;
  onSubmit?: any;
  className?: string;
}

export const Form = ({
  children = undefined,
  formId = undefined,
  onSubmit = undefined,
  className = undefined,
}: IProps): JSX.Element => (
  <Col className={`Form ${className}`} as={RBForm} id={formId} xs={12} xl={6} onSubmit={onSubmit}>
    {children}
  </Col>
);

export * from './FormInput/FormInput';
export * from './FormChangesUI/FormChangesUI';
export * from './FormSection/FormSection';
export * from './FormWarning/FormWarning';

Form.defaultProps = {
  children: undefined,
  formId: undefined,
  onSubmit: undefined,
  className: undefined,
};
